import React, { useState, useRef, useEffect } from "react";
import "../Bfsi Solution/faq.css";

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const answerRefs = useRef([]);

  const faqs = [
    {
      q: "What Services Does Your Shipping and Logistics Software Development Company Offer?",
      a: "We offer comprehensive services, including the development of custom shipping and logistics software, order tracking systems, route optimization solutions, and more.",
    },
    {
      q: "Can You Develop a Customized Shipping and Logistics Solution Tailored to Our Specific Business Requirements?",
      a: "Absolutely. We specialize in developing tailored solutions to meet the unique needs and challenges of our clients in the shipping and logistics industry.",
    },
    {
      q: "How Does Your Software Address Real-time Order and Shipment Tracking?",
      a: "Our software provides real-time tracking capabilities, allowing users to monitor the status and location of their orders and shipments, ensuring transparency and customer satisfaction.",
    },
    {
      q: "Do You Integrate Route Optimization Algorithms for Efficient Delivery Planning?",
      a: "Yes, we integrate route optimization algorithms to plan and optimize delivery routes, reducing costs, and improving overall delivery efficiency.",
    },
    {
      q: "Can Your Software Manage Warehouse Operations, Including Inventory Management and Order Picking?",
      a: "Certainly. We develop Warehouse Management Systems (WMS) to streamline warehouse operations, optimizing inventory management and order fulfillment processes.",
    },
    {
      q: "How Do You Ensure Fleet Management and Monitor Vehicle Performance in Your Software Solutions?",
      a: "Our software includes comprehensive fleet management features, allowing businesses to monitor vehicle performance, track maintenance schedules, and enhance overall fleet efficiency.",
    },
    {
      q: "Does Your Software Provide Tools for Supplier Collaboration and Real-time Communication?",
      a: "Yes, we incorporate tools for supplier collaboration, facilitating real-time communication, order updates, and inventory synchronization for a seamless supply chain.",
    },
    {
      q: "How Does Your Software Handle Customs Documentation and Compliance for International Shipments?",
      a: "We include features for managing customs documentation, compliance checks, and regulatory requirements to ensure smooth international shipments.",
    },
    {
      q: "What Kind of Real-time Alerts and Notifications Does Your Software Offer to Keep Users Informed?",
      a: "Our software provides real-time alerts and notifications for various events, such as delivery updates, delays, and exceptions in the shipping process.",
    },
    {
      q: "Can Your Software Integrate With E-commerce Platforms for Automatic Order Processing and Inventory Updates?",
      a: "Absolutely. We ensure seamless integration with e-commerce platforms for automatic order processing, real-time inventory updates, and synchronization of shipping information.",
    },
     {
      q: "Is There a Customer Portal for Self-service, Allowing Customers to Track Orders and Manage Shipments?",
      a: "Yes, we design customer portals that empower users with self-service capabilities, enabling them to track orders, view delivery schedules, and manage shipments conveniently.",
    },
     {
      q: "What Kind of Data Analytics and Reporting Tools Does Your Software Offer for Performance Tracking?",
      a: "Our software includes robust analytics tools to track and analyze key performance indicators (KPIs), providing insights into delivery times, order accuracy, and inventory turnover.",
    },
     {
      q: "Is There a Mobile App for Drivers and Field Operations to Enhance Mobility and Communication?",
      a: "Yes, we develop mobile apps for drivers and field personnel, facilitating assignment updates, real-time information access, and improved operational efficiency.",
    },
     {
      q: "How Does Your Software Address Environmental Sustainability in Logistics Operations?",
      a: "We integrate features to monitor and optimize fuel consumption, reduce carbon emissions, and implement eco-friendly logistics practices, contributing to environmental sustainability.",
    },
  ];

  const toggleFaq = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  // Get height for smooth animation
  const getHeight = (index) => {
  const el = answerRefs.current[index];
  if (!el) return "0px";

  const padding = 40; // top 20 + bottom 20
  return `${el.scrollHeight + padding}px`;
};


  return (
    <div className="faq-wrapper">
      <h2 className="faq-title">Faq's</h2>

      {faqs.map((item, index) => (
        <div
          className={`faq-item ${activeIndex === index ? "active" : ""}`}
          key={index}
        >
          <div className="faq-question" onClick={() => toggleFaq(index)}>
            <span>{item.q}</span>
            <span className="faq-icon">
              {activeIndex === index ? "−" : "+"}
            </span>
          </div>

          {/* Smooth answer */}
          <div
            className="faq-answer"
            ref={(el) => (answerRefs.current[index] = el)}
            style={{
              maxHeight: activeIndex === index ? getHeight(index) : "0px",
            }}
          >
            <p>{item.a}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Faq;
